import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=bf9229b0"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf9229b0')) {
      api.createRecord('bf9229b0', component.options)
    } else {
      api.reload('bf9229b0', component.options)
    }
    module.hot.accept("./popover.vue?vue&type=template&id=bf9229b0", function () {
      api.rerender('bf9229b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/info/popover.vue"
export default component.exports